import * as React from 'react';
import { ArticleParagraph2, Tooltip } from '@cian/ui-kit';
import * as styles from './DescriptionTooltip.css';

interface IDescriptionLinkProps {
  text: string;
  popupText: string;
}

export function DescriptionTooltip({ text, popupText }: IDescriptionLinkProps) {
  return (
    <Tooltip title={popupText}>
      <button className={styles['button']}>
        <ArticleParagraph2 color={'primary_100'}>{text}</ArticleParagraph2>
      </button>
    </Tooltip>
  );
}
